{
  "formation_requests": {
    "sidebar_link": "New Organization Request",
    "accept_success": "Organization Request has been accepted.",
    "reject_success": "Organization Request has been rejected.",
    "form_title": "New Organization Request",
    "view_title": "View Organization Request",
    "list_title": "List of Organization Requests",
    "list_link": "List of all requests",
    "new_link": "New Request",
    "send_request": "Send Request",
    "create_formation_request": "Organization Request",
    "go_to_index": "Back To Organizations",
    "empty_list": "No organization requests"
  }
}
